<template>
  <div>
    <v-row no-gutters class="" style="height: 50px;">
      <div class="d-flex justify-space-between" :style="'width: 100%;background-color:' + (levelById && levelById.color)">
        <div style="margin: auto 20px;">
          <v-btn icon @click="backBtn()">
            <v-icon :color="HEXToVBColorLMG(levelById.color)" class="mr-2" style="padding-bottom: 1px;">mdi-chevron-left</v-icon>
          </v-btn>
          <span :style="'color:' + HEXToVBColorLMG(levelById.color)">{{ $t("message.pointHistory") }}</span>
        </div>
        <!-- <div style="margin: auto 15px;padding-right: 10px;">
          <v-badge :content="countNoti" :value="countNoti" color="red" overlap>
            <v-menu
              max-height="500"
              min-width="330"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-chip class="mr-5" @click="changlangue()">
                  <v-avatar left>
                    <v-img :src="$i18n.locale === 'th' ? thai : eng"></v-img>
                  </v-avatar>
                  <b :style="{'color': $CUSTOMMainTextColor}">{{ $t("message.language") }}</b>
                </v-chip>
                <transition appear name="fade-slide">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    style="
                      font-size: 26px;
                    "
                    @click="removeNoti()"
                    large
                    :color="HEXToVBColorLMG(levelById.color)"
                  >
                    mdi-bell-ring-outline
                  </v-icon>
                </transition>
              </template>
              <v-card
                v-show="
                  notificationshow.length > 0 || notificationshowed.length > 0
                "
              >
                <h4
                  style="padding-left: 16px; margin-bottom: 0px;padding-top: 20px;"
                  v-show="text === true || notificationshow.length > 0"
                >
                {{ $t("message.new") }}
                </h4>
                <div
                  style="margin-bottom: 1px;padding: 10px;padding-bottom: 10px;"
                  v-for="(item, i) in notificationshow"
                  :key="i"
                >
                  <div style="border: solid #dadada;padding: 7px;border-radius: 10px;">
                    <v-icon color="#ffb000" style="border-radius: 50%; width: 40px; height: 40px">mdi-bell</v-icon>
                    <v-chip small :color="checkColor2(item)" :style="{'color': $CUSTOMMainTextColor}">{{ checkTypeNoti(item) }}</v-chip>
                    <div style="padding-left: 45px;">
                      <v-row
                        style="margin-top: 3px;font-size: 14px;font-weight: bold;"
                      >
                        <v-col cols="6" class="pt-0">
                          <div style="margin-bottom: 5px;">
                            {{ checkREdeemOruse(item) }}
                          </div>
                        </v-col>
                        <v-col
                          cols="6"
                          class="d-flex pt-0"
                          style="justify-content: end;"
                        >
                          <span
                            :style="
                              'color:' + checkColor(item) + ';padding-right: 5px'
                            "
                            >{{ checkSymbol(item) }}
                            {{ formatNumber(item.details.split(" ")[1]) }}
                          </span>
                          {{ $t("message.point") }}
                        </v-col>
                      </v-row>
                      <div v-if="shopId === 'U53696ebf2bc8effeb59061ce66ade036' && !item.lmgStatusSpecailpoint && checkShowOrNot(item)" class="mb-2" style="font-size: 13px;color: #666666;font-weight: 400; ">
                        <span class="d-flex justify-space-between">
                          - {{ $t("message.youGet")}} Base Point
                          <div>
                            <p class="mb-0">{{item.basePoint}} {{ $t("message.point") }}</p>
                          </div>
                        </span>
                        <span class="d-flex justify-space-between">
                        - {{ $t("message.youGet")}} Base Point % Tier Point
                          <div>
                            <p class="mb-0">{{parseInt(item.details.split(" ")[1]) - item.basePoint}} {{ $t("message.point") }}</p>
                          </div>
                        </span>
                      </div>
                      <div
                        style="font-size: 12px;color: #404040;margin-bottom: 10px;"
                      >
                        {{ moreDetail(item) }} {{ checkTopic(item) }}
                      </div>
                      <div style="font-size: 12px;">
                        <v-icon
                          color="#9c9c9c"
                          style="font-size: 20px;padding-bottom: 5px;"
                          >mdi-calendar</v-icon
                        >
                        <span style="color:rgb(134 134 134 / 90%);">
                          {{
                            new Date(item.CREATE_DATE).toISOString().slice(0, 10)
                          }}
                          <span style="color: rgb(134 134 134 / 90%);">
                            <v-icon
                              color="#9c9c9c"
                              style="font-size: 20px;padding-bottom: 5px;"
                              >mdi-clock</v-icon
                            >
                            {{
                              new Date(item.CREATE_DATE).toISOString().slice(11, 16)
                            }}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <h4
                  style="padding-left: 16px; margin-bottom: 10px;padding-top: 20px;font-weight: bolder;font-size: 20px;"
                  v-show="notificationshowed.length > 0"
                >
                {{ $t("message.before") }}
                </h4>
                <div
                  style="margin-bottom: 1px;padding: 10px;padding-bottom: 10px;"
                  v-for="(item, i) in notificationshowed"
                  :key="i"
                >
                  <div style="border: solid #dadada;padding: 7px;border-radius: 10px;">
                    <v-icon color="#ffb000" style="border-radius: 50%; width: 40px; height: 40px">mdi-bell</v-icon>
                    <v-chip small :color="checkColor2(item)" :style="{'color': $CUSTOMMainTextColor}">{{ checkTypeNoti(item) }}</v-chip>
                    <div style="padding-left: 45px;">
                      <v-row style="margin-top: 3px;font-size: 14px;font-weight: bold;">
                        <v-col cols="6" class="pt-0">
                          <div style="margin-bottom: 5px;">
                            {{ checkREdeemOruse(item) }}
                          </div>
                        </v-col>
                        <v-col cols="6" class="d-flex pt-0" style="justify-content: end;">
                          <span :style="'color:' + checkColor(item) + ';padding-right: 5px'">{{ checkSymbol(item)}} {{ formatNumber(item.details.split(' ')[1]) }} </span> {{ $t("message.point") }}
                        </v-col>
                      </v-row>
                      <div v-if="shopId === 'U53696ebf2bc8effeb59061ce66ade036' && !item.lmgStatusSpecailpoint && checkShowOrNot(item)" class="mb-2" style="font-size: 13px;color: #666666;font-weight: 400; ">
                          <span class="d-flex justify-space-between">
                            - Base Point
                            <div>
                              <p class="mb-0">{{item.basePoint}} {{ $t("message.point") }}</p>
                            </div>
                          </span>
                          <span class="d-flex justify-space-between">
                            - % Tier Point
                            <div>
                              <p class="mb-0">{{parseInt(item.details.split(" ")[1]) - item.basePoint}} {{ $t("message.point") }}</p>
                            </div>
                          </span>
                    </div>
                      <div style="font-size: 12px;color: #404040;margin-bottom: 10px;">
                        {{ moreDetail(item) }} {{ checkTopic(item) }}
                      </div>
                      <div style="font-size: 12px;">
                        <v-icon color="#9c9c9c" style="font-size: 20px;padding-bottom: 5px;">mdi-calendar</v-icon>
                        <span style="color:rgb(134 134 134 / 90%);">
                          {{
                            new Date(item.CREATE_DATE).toISOString().slice(0, 10)
                          }}
                          <span style="color: rgb(134 134 134 / 90%);">
                            <v-icon color="#9c9c9c" style="font-size: 20px;padding-bottom: 5px;">mdi-clock</v-icon>
                            {{
                              new Date(item.CREATE_DATE).toISOString().slice(11, 16)
                            }}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </v-card>
            </v-menu>
          </v-badge>
        </div> -->
      </div>
    </v-row>
    <div class="mt-0">
      <v-col cols="12" class="pa-0">
        <v-card flat
            tile>
          <v-tabs
            fixed-tabs
            background-color="white"
            v-model="tab"
            :color="tabTextColor"
          >
            <v-tab>
              {{ $t("message.getTopicPoint") }}
            </v-tab>
            <v-tab>
              {{ $t("message.useTopicPoint") }}
            </v-tab>
            <v-tab>
              {{ $t("message.expirePoint2") }}
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab" style="min-height:100vh;background-color: #F2F2F2;">
            <v-tab-item style="background-color: #F2F2F2;">
              <v-card flat tile>
                <div v-show="overlay" style="text-align: center;padding-top: 250px;">
                  <v-progress-circular
                    indeterminate
                    size="24"
                  ></v-progress-circular>
                </div>
                <v-card-text v-if="Array.isArray(formUpdate) && formUpdate.length > 0 && !overlay" style="min-height:100vh; background: #F2F2F2;" class="pa-5">
                  <v-card flat tile v-for="(item, i) in formUpdate" :key="i" class="mb-4" min-height="101" style="border-radius: 15px;">
                    <p class="mb-0 pa-3 pb-1">{{ checkTypeNoti2(item) }}</p>
                    <p v-if="!$isTargetShop()" class="mb-0 px-3 mb-2" style="font-weight: bold;">{{ checkTopic2(item) }}</p>
                    <!-- lmg -->
                    <div v-else class="mb-0 px-3 mb-2 d-flex justify-space-between">
                      <p class="mb-0 pa-0 mb-2" style="font-weight: bold;display: flex;align-items: center;">{{ checkTopic2(item) }}</p>
                      <div class="pr-0">
                        <v-chip color="#FFB400" dark :style="{'color': $CUSTOMMainTextColor}">
                          + {{ item.point ? item.point + item.lmgPersentTirePoint : item.coin }} {{ $t("message.point") }}
                        </v-chip>
                      </div>
                    </div>
                    <div v-if="$isTargetShop && !item.lmgStatusSpecailpoint && checkShowOrNot2(item)" class="mb-2 px-3" style="font-size: 15px;color: #666666;font-weight: 400; ">
                      <span class="d-flex justify-space-between pr-3">
                        - Base Point
                        <div>
                          <p class="mb-0">{{item.point}} {{ $t("message.point") }}</p>
                        </div>
                      </span>
                      <span class="d-flex justify-space-between pr-3">
                      - % Tier Point
                        <div>
                          <p class="mb-0">{{item.lmgPersentTirePoint}} {{ $t("message.point") }}</p>
                        </div>
                      </span>
                    </div>
                    <!-- lmg -->
                    <div class="mb-0 px-3 mb-2" v-if="item.bvpBillingNumber && !item.quetionaire">
                        <v-btn
                          block
                          dark
                          small
                          :style="'color:' + HEXToVBColorLMG(levelById.color) + '!important'"
                          @click="getDetailBpv(item)"
                        >
                          <v-icon>mdi-magnify</v-icon>{{ $t("message.seeMore") }}
                        </v-btn>
                      </div>
                    <div class="d-flex justify-space-between pb-4">
                      <div class="mb-0 px-3" style="margin: auto 0;">
                        <v-icon v-if="!isTargetShop"  color="#9c9c9c" style="font-size: 20px;padding-bottom: 5px;">mdi-calendar</v-icon>
                          <span style="color:rgb(134 134 134 / 90%);">
                            {{
                              !$isTargetShop
                                ? new Date(item.LAST_DATE).toISOString().slice(0, 10).replace(/-/g, '/')
                                : (item.title ? new Date(item.LAST_DATE).toISOString().slice(0, 10).replace(/-/g, '/') : formatDate(item.CREATE_DATE))
                            }}
                          <span style="color: rgb(134 134 134 / 90%);">
                            <v-icon v-if="!isTargetShop" color="#9c9c9c" style="font-size: 20px;padding-bottom: 5px;">mdi-clock</v-icon>
                            <!-- {{
                              item.CREATE_DATE
                            }} -->
                            {{
                              !$isTargetShop ? new Date(item.LAST_DATE).toISOString().slice(11, 16) :
                              (item.title ? new Date(item.LAST_DATE).toISOString().slice(11, 16):formatTime(item.CREATE_DATE))
                            }}
                          </span>
                        </span>
                      </div>
                      <!-- <div class="pr-3">
                        <v-chip color="#FFB400" dark :style="{'color': $CUSTOMMainTextColor}">
                          + {{ item.point ? item.point : item.coin }} {{ $t("message.point") }}
                        </v-chip>
                      </div> -->
                    </div>
                    <!-- {{ item.point ? item.point : item.coin }} -->
                    <!-- {{
                          new Date(item.CREATE_DATE).toISOString().slice(0, 10)
                        }}
                    {{
                            new Date(item.CREATE_DATE).toISOString().slice(11, 16)
                          }} -->
                  </v-card>
                  <!-- <v-data-table
                  :headers="columns1"
                  :items="formUpdate"
                  :items-per-page="10"
                  dense
                  >
                    <template v-slot:[`item.LAST_DATE`]="{ item }">
                      {{ format_date(item.LAST_DATE) }}
                    </template>
                    <template v-slot:[`item.coin`]="{ item }"> {{ formatNumber(item.coin) }} </template>
                  </v-data-table> -->
                </v-card-text>
                <v-card-text v-show="!overlay" v-else style="min-height:100vh;text-align: center;padding-top: 200px !important;font-size: 16px;">
                  <v-icon large
                  >mdi-package-variant-remove</v-icon>
                  <div>{{ $t("message.noData") }}</div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item style="background-color: #F2F2F2;">
              <v-card flat tile >
                <div v-show="overlay" style="text-align: center;padding-top: 250px;">
                  <v-progress-circular
                    indeterminate
                    size="24"
                  ></v-progress-circular>
                </div>
                <v-card-text v-if="Array.isArray(dataRedeem) && dataRedeem.length > 0 && !overlay" style="min-height:100vh;    background: #F2F2F2;" class="pa-5">
                  <v-card flat tile v-for="(item, i) in dataRedeem" :key="i" class="mb-4" min-height="101" style="border-radius: 15px;">
                    <p class="mb-0 pa-3 pb-1">{{ item.source == 'redeem' ? $t("message.redeemReward") : ($isTargetShop ? $t("message.productsServicesLMG") : $t("message.productsServices"))}}</p>
                    <p class="mb-0 px-3 mb-2" style="font-weight: bold;">{{ checkReward(item) }}</p>
                    <div class="d-flex justify-space-between pb-4">
                      <div class="mb-0 px-3" style="margin: auto 0;">
                        <v-icon color="#9c9c9c" style="font-size: 20px;padding-bottom: 5px;">mdi-calendar</v-icon>
                          <span style="color:rgb(134 134 134 / 90%);">
                          {{
                            new Date(item.LAST_DATE).toISOString().slice(0, 10).replace(/-/g, '/')
                          }}
                          <span style="color: rgb(134 134 134 / 90%);">
                            <v-icon color="#9c9c9c" style="font-size: 20px;padding-bottom: 5px;">mdi-clock</v-icon>
                            {{
                              new Date(item.LAST_DATE).toISOString().slice(11, 16)
                            }}
                          </span>
                        </span>
                      </div>
                      <div class="pr-3">
                        <v-chip color="red" dark>
                          - {{ item.point ? item.point : item.coin }} {{ $t("message.point") }}
                        </v-chip>
                      </div>
                    </div>
                    <!-- {{ item.point ? item.point : item.coin }} -->
                    <!-- {{
                          new Date(item.CREATE_DATE).toISOString().slice(0, 10)
                        }}
                    {{
                            new Date(item.CREATE_DATE).toISOString().slice(11, 16)
                          }} -->
                  </v-card>
                  <!-- <v-data-table
                  :headers="columns1"
                  :items="formUpdate"
                  :items-per-page="10"
                  dense
                  >
                    <template v-slot:[`item.LAST_DATE`]="{ item }">
                      {{ format_date(item.LAST_DATE) }}
                    </template>
                    <template v-slot:[`item.coin`]="{ item }"> {{ formatNumber(item.coin) }} </template>
                  </v-data-table> -->
                </v-card-text>
                <v-card-text v-show="!overlay" v-else style="min-height:100vh;text-align: center;padding-top: 200px !important;font-size: 16px;">
                  <v-icon large
                  >mdi-package-variant-remove</v-icon>
                  <div>{{ $t("message.noData") }}</div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item style="background-color: #F2F2F2;">
              <v-card flat tile >
                <div v-show="overlay" style="text-align: center;padding-top: 250px;">
                  <v-progress-circular
                    indeterminate
                    size="24"
                  ></v-progress-circular>
                </div>
                <v-card-text v-if="Array.isArray(expireCoin) && expireCoin.length > 0 && !overlay" style="min-height:100vh; background: #F2F2F2;" class="pa-5">
                  <v-card flat tile v-for="(item, i) in expireCoin" :key="i" class="mb-4" min-height="101" style="border-radius: 15px;">
                    <p class="mb-0 pa-3 pb-1">{{ $t("message.expirePointTopic") }}</p>
                    <div class="d-flex justify-space-between pb-4">
                      <div class="mb-0 px-3" style="margin: auto 0;">
                        <v-icon color="#9c9c9c" style="font-size: 20px;padding-bottom: 5px;">mdi-calendar</v-icon>
                          <span style="color:rgb(134 134 134 / 90%);">
                          {{
                            new Date(item.LAST_DATE).toISOString().slice(0, 10).replace(/-/g, '/')
                          }}
                          <span style="color: rgb(134 134 134 / 90%);">
                            <v-icon color="#9c9c9c" style="font-size: 20px;padding-bottom: 5px;">mdi-clock</v-icon>
                            {{
                              new Date(item.LAST_DATE).toISOString().slice(11, 16)
                            }}
                          </span>
                        </span>
                      </div>
                      <div class="pr-3">
                        <v-chip color="red" dark>
                          - {{ item.balancePoint }} {{ $t("message.point") }}
                        </v-chip>
                      </div>
                    </div>
                    <!-- {{ item.point ? item.point : item.coin }} -->
                    <!-- {{
                          new Date(item.CREATE_DATE).toISOString().slice(0, 10)
                        }}
                    {{
                            new Date(item.CREATE_DATE).toISOString().slice(11, 16)
                          }} -->
                  </v-card>
                  <!-- <v-data-table
                  :headers="columns1"
                  :items="formUpdate"
                  :items-per-page="10"
                  dense
                  >
                    <template v-slot:[`item.LAST_DATE`]="{ item }">
                      {{ format_date(item.LAST_DATE) }}
                    </template>
                    <template v-slot:[`item.coin`]="{ item }"> {{ formatNumber(item.coin) }} </template>
                  </v-data-table> -->
                </v-card-text>
                <v-card-text v-show="!overlay" v-else style="min-height:100vh;text-align: center;padding-top: 200px !important;font-size: 16px;">
                  <v-icon large
                  >mdi-package-variant-remove</v-icon>
                  <div>{{ $t("message.noData") }}</div>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
        <!-- <div v-if="!dataReady" class="text-center">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div> -->
      </v-col>
    </div>
    <v-dialog
      v-model="dialog"
      hide-overlay
    >
      <v-card flat tile>
        <v-toolbar
          dark
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon :style="'color:' + HEXToVBColorLMG(levelById.color) + '!important'">mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title :style="'color:' + HEXToVBColorLMG(levelById.color) + '!important'">รายละเอียดสินค้า</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-list>
          <v-list-item v-for="(item, i) in dataDetil" :key="i">
            <v-list-item-content >
              <v-card max-width="100%">
                <v-row>
                  <v-col cols="5">
                    <h6>{{ $t("message.model") }}:</h6>
                  </v-col>
                  <v-col cols="5">
                    <v-list-item-subtitle>{{ item.MODEL }}</v-list-item-subtitle>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5">
                    <h6>{{ $t("message.proType") }}:</h6>
                  </v-col>
                  <v-col cols="7">
                    <v-list-item-subtitle>{{ item.CategoryType }}</v-list-item-subtitle>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5">
                    <h6>{{ $t("message.branch") }}:</h6>
                  </v-col>
                  <v-col cols="7">
                    <v-list-item-subtitle>{{ item.BRANCHNAME }}</v-list-item-subtitle>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5">
                    <h6>{{ $t("message.price") }}:</h6>
                  </v-col>
                  <v-col cols="7">
                    <v-list-item-subtitle>{{ item.F_NETEXPRICE }} ฿</v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-card>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import LineChart from '../../Chart/Line.js'
import axios from 'axios' // api
export default {
  components: {
    LineChart
  },
  data () {
    return {
      levelById: null,
      shopId: null,
      datacollection: null,
      overlay: true,
      text: true,
      member: null,
      profile: null,
      dialog: false,
      thai: 'https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2Fflag-TH.png?alt=media&token=e4bd7ffa-aed9-47e3-9240-4dcb9d8d284e',
      eng: 'https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2Fflag-USA1.png?alt=media&token=a83dd820-f576-457a-8d08-1009cea9d70b',
      level: null,
      transaction: null,
      chartData: [],
      chartLabel: [],
      formUpdate: [],
      formUpdate1: [],
      expireCoin: [],
      notificationshow: [],
      notificationshowed: [],
      dataRedeem: [],
      countNoti: null,
      urlQRCode: null,
      tab: null,
      columns1: [
        { text: this.$t('message.date'), value: 'LAST_DATE' },
        {text: this.$t('message.activity'), value: 'title'},
        { text: 'coin', value: 'coin' }
      ],
      columns2: [
        { text: this.$t('message.date'), value: 'LAST_DATE' },
        { text: 'coin', value: 'point' },
        { text: 'BillingNumber', value: 'bvpBillingNumber' },
        { text: 'ดูรายละเอียด', value: 'action', sortable: false, align: 'center' }
      ],
      datacheck: [],
      columns4: [
        { text: this.$t('message.date'), value: 'LAST_DATE' },
        { text: 'coin', value: 'point' },
        { text: this.$t('message.branch'), value: 'branchName' },
        { text: this.$t('message.productsServices'), value: 'productExchangeRateName' }
      ],
      columns3: [
        { text: this.$t('message.date'), value: 'LAST_DATE' },
        { text: 'point', value: 'balancePoint' }
      ],
      dataDetil: null,
      notishow: true,
      options: {
        cutoutPercentage: 100,
        aspectRatio: 1,
        legend: {
          display: false
        },
        title: {
          display: false
        },
        layout: {
          padding: {
            left: 0,
            right: 0
            // top: 0,
            // bottom: 0
          }
        }
      }
    }
  },
  computed: {
    isTargetShop () {
      return this.$isTargetShop()
    },
    tabTextColor () {
      if (this.levelById && this.levelById.color) {
        try {
          if (this.isWhiteTone(this.levelById.color)) return this.$bgColor
          else return this.$bgColor
        } catch (e) {
          // ignore
        }
      }
      // prefer converted readable color if available
      try {
        const conv = typeof this.HEXToVBColorLMG === 'function' ? this.HEXToVBColorLMG(this.levelById && this.levelById.color) : null
        return conv || (this.levelById && this.levelById.color) || '#000000'
      } catch (e) {
        return (this.levelById && this.levelById.color) || '#000000'
      }
    }
  },
  async mounted () {
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    this.shopId = this.GET_SHOPID()
    this.level = this.getLevel()
    await this.getNotify()
    await this.getTransaction()
    await this.getLevelById()
    this.getExpireCoin()
    this.overlay = false
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapActions('memberStore', ['getMemberProfile']),
    ...mapGetters('shopStore', ['GET_SHOPID']),
    backBtn () {
      window.history.back()
    },
    formatDate (dateStr) {
      const date = new Date(dateStr)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}/${month}/${day}`
    },
    formatTime (dateStr) {
      const date = new Date(dateStr)
      date.setHours(date.getHours() - 7) // ลบ 7 ชั่วโมง

      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${hours}:${minutes}`
    },
    async getLevelById () {
      const result = await this.callBeTaskAPI(
        'get',
        `/level/getID?RECORD_STATUS=N&levelId=${this.member.levelId}`
      )

      if (result) {
        this.levelById = result
        return result
      }
    },
    checkShowOrNot (item) {
      if (item.source === 'collect') {
        if (item.name === 'รายการรับคะแนน') {
          if (
            item.topicNameTh === '' ||
            item.topicNameTh === null ||
            item.topicNameTh === 'None'
          ) {
            if (item.packageName) {
              return false
            } else {
              if (!this.$isTargetShop()) {
                return false
              } else {
                return item.lmgStatusSpecailpoint !== 'True'
              }
            }
          } else if (item.packageName !== null) {
            return false
          } else {
            return false
          }
        } else if (item.name === 'รายการรับคะแนน welcome point') {
          return false
        } else if (
          item.name === 'รายการรับคะแนน จากการชวนเพื่อนเข้าใช้บริการ'
        ) {
          return false
        } else if (item.name === 'รายการรับคะแนน วันเกิด') {
          return false
        } else if (item.name === 'รายการรับคะแนนจากกิจกรรม Friend get Friend') {
          return false
        } else if (item.name === 'รายการรับคะแนนแบบสอบถาม') {
          return false
        }
      } else if (item.source === 'redeem') {
        return false
      } else {
        if (!this.$isTargetShop()) {
          return false
        } else {
          return item.lmgStatusSpecailpoint !== 'True'
        }
      }
    },
    checkReward (item) {
      if (item.source === 'redeem') {
        if (this.$i18n.locale === 'th') {
          return item.topicNameTh
        } else {
          return item.topicNameEng
        }
      } else {
        if (item.refId && item.refId !== '') {
          return `${this.$t('message.fromRefund')}${this.$t('message.billingNo')}: ${item.refId}`
        } else {
          return this.$t('message.fromRefund')
        }
      }
    },
    checkColor2 (item) {
      switch (item.name) {
        case 'รายการรับคะแนน':
        case 'รายการรับคะแนน welcome point':
        case 'รายการรับคะแนนแบบสอบถาม':
        case 'รายการรับคะแนนจากกิจกรรม Friend get Friend':
        case 'รายการรับคะแนน วันเกิด':
          return 'rgb(86 202 0 / 16%)'
        default:
          return 'rgb(255 76 81 / 16%)'
      }
    },
    checkColor (item) {
      switch (item.name) {
        case 'รายการรับคะแนน':
        case 'รายการรับคะแนน welcome point':
        case 'รายการรับคะแนนแบบสอบถาม':
        case 'รายการรับคะแนนจากกิจกรรม Friend get Friend':
        case 'รายการรับคะแนน วันเกิด':
          return 'green'
        default:
          return 'red'
      }
    },
    checkSymbol (item) {
      switch (item.name) {
        case 'รายการรับคะแนน':
        case 'รายการรับคะแนน welcome point':
        case 'รายการรับคะแนนแบบสอบถาม':
        case 'รายการรับคะแนนจากกิจกรรม Friend get Friend':
        case 'รายการรับคะแนน วันเกิด':
          return '+'
        default:
          return '-'
      }
    },
    checkREdeemOruse (item) {
      switch (item.source) {
        case 'collect':
          return this.$t('message.yougetPoint')
        case 'redeem':
          return this.$t('message.youUsePoint')
        case 'refund':
          return this.$t('message.youRefund')
        case 'expire':
          return this.$t('message.expirePointTopic')
      }
    },
    async removeNoti () {
      this.countNoti = 0
      await axios.post(
        this.DNS_IP +
          `/update-status-notify/update?lineUserId=${this.profile.userId}&shopId=${this.shopId}`,
        {
          headers: {
            lineUserId: this.profile.userId,
            lineId: this.profile.userId,
            shopId: this.shopId
          }
        }
      )
      // const result = await this.callBeTaskAPI(
      //   'post',
      //   `/update-status-notify/update?lineUserId=${this.profile.userId}&shopId=${this.member.shopId}`
      // )
      // console.log('update', result)
    },
    async getNotify () {
      const result = await axios.get(
        this.DNS_IP +
          `/notify/get?memberId=${this.profile.memberId}&shopId=${this.shopId}`,
        {
          headers: {
            lineUserId: this.profile.userId,
            lineId: this.profile.userId,
            shopId: this.member.shopId
          }
        }
      )
      // const result = await this.callBeTaskAPI(
      //   'get',
      //   `/notify/get?lineUserId=${this.member.lineUserId}&shopId=${this.member.shopId}`
      // )
      if (result.data.length > 0) {
        this.notificationshow = result.data.filter(
          (item) => item.notifyStatus === 'show'
        )
        this.notificationshowed = result.data.filter(
          (item) => item.notifyStatus === 'showed'
        )
        this.countNoti = this.notificationshow.length
        if (result.data.find((item) => item.notifyStatus === 'showed')) {
          this.text = false
        } else if (result.data.find((item) => item.notifyStatus === 'show')) {
          this.text = true
        }
      } else {
      }
    },
    checkTopic (item) {
      if (item.source === 'collect') {
        if (item.name === 'รายการรับคะแนน') {
          if (item.refId !== '' && item.refId !== 'None' && item.refId !== null) {
            if (item.packageName) {
              return item.packageName
            } else {
              return `${this.$t('message.billingNo')}: ${item.refId}`
            }
          } else {
            if (this.$i18n.locale === 'th') {
              return item.topicNameTh
            } else {
              return item.topicNameEng
            }
          }
        } else if (item.name === 'รายการรับคะแนนแบบสอบถาม') {
          return `${this.$t('message.billingNo')}: ${item.refId}`
        }
      } else if (item.source === 'redeem') {
        if (this.$i18n.locale === 'th') {
          return item.topicNameTh
        } else {
          return item.topicNameEng
        }
      } else {
        if (item.refId !== '' && item.refId !== 'None' && item.refId !== null) {
          return `${this.$t('message.billingNo')}: ${item.refId}`
        } else {

        }
      }
    },
    moreDetail (item) {
      if (item.source === 'collect') {
        if (item.name === 'รายการรับคะแนน') {
          if (item.topicNameTh === '' || item.topicNameTh === null || item.topicNameTh === 'None') {
            if (item.packageName) {
              return this.$t('message.fromPackage')
            } else {
              return !this.$isTargetShop ? this.$t('message.fromBuyAndService') : this.$t('message.yougetPoint')
            }
          } else {
            return this.$t('message.activity')
          }
        } else if (item.name === 'รายการรับคะแนน welcome point') {
          return this.$t('message.fromWelcome')
        } else if (item.name === 'รายการรับคะแนน จากการชวนเพื่อนเข้าใช้บริการ') {
          return this.$t('message.fromBuyAndService')
        } else if (item.name === 'รายการรับคะแนน วันเกิด') {
          return this.$t('message.fromBirth')
        } else if (item.name === 'รายการรับคะแนนจากกิจกรรม Friend get Friend') {
          return this.$t('message.fromFrigetFri')
        } else if (item.name === 'รายการรับคะแนนแบบสอบถาม') {
          return this.$t('message.fromFeedBack')
        }
      } else if (item.source === 'redeem') {
        return this.$t('message.useForRedeem')
      } else if (item.source === 'expire') {
        return this.$t('message.expirePointTopic')
      } else {
        return this.$t('message.fromRefund')
      }
    },
    checkTypeNoti (item) {
      // กิจกรรม แบบสอบถาม แลกของรางวัล สินค้า/บริการ
      if (item.source === 'collect') {
        if (item.name === 'รายการรับคะแนน') {
          if (
            item.topicNameTh === '' ||
            item.topicNameTh === null ||
            item.topicNameTh === 'None'
          ) {
            if (item.packageName) {
              return this.$t('message.package')
            } else {
              if (!this.$isTargetShop()) {
                return this.$t('message.productsServices')
              } else {
                return item.lmgStatusSpecailpoint === 'True' ? this.$t('message.specailLMG') : this.$t('message.productsServicesLMG')
              }
            }
          } else if (item.packageName !== null) {
            return this.$t('message.package')
          } else {
            return this.$t('message.activity')
          }
        } else if (item.name === 'รายการรับคะแนน welcome point') {
          return this.$t('message.activity')
        } else if (
          item.name === 'รายการรับคะแนน จากการชวนเพื่อนเข้าใช้บริการ'
        ) {
          return this.$t('message.activity')
        } else if (item.name === 'รายการรับคะแนน วันเกิด') {
          return this.$t('message.activity')
        } else if (item.name === 'รายการรับคะแนนจากกิจกรรม Friend get Friend') {
          return this.$t('message.activity')
        } else if (item.name === 'รายการรับคะแนนแบบสอบถาม') {
          return this.$t('message.feedBack')
        }
      } else if (item.source === 'redeem') {
        return this.$t('message.redeemReward')
      } else if (item.source === 'expire') {
        return this.$t('message.expirePointTopic')
      } else {
        if (!this.$isTargetShop()) {
          return this.$t('message.productsServices')
        } else {
          return item.lmgStatusSpecailpoint === 'True' ? this.$t('message.specailLMG') : this.$t('message.productsServicesLMG')
        }
      }
    },
    async changlangue () {
      this.$i18n.locale = this.$i18n.locale === 'th' ? 'en' : 'th'
      await axios.post(
        this.DNS_IP +
          `/member/edit/${this.profile.memberId}`, {'language': this.$i18n.locale}
      )
      await this.getMemberProfile()
    },
    checkTopic2 (item) {
      if (item.title) {
        return item.title
      } else if (item.quetionaire) {
        return `${this.$t('message.billingNo')}: ${item.bvpBillingNumber}`
      } else {
        if (item.bvpBillingNumber) {
          return `${this.$t('message.billingNo')}: ${item.bvpBillingNumber}`
        } else {
          if (item.packageName) {
            return this.$t('message.package') + ' ' + item.packageName
          } else {
            if (item.name === 'รายการรับคะแนนจากกิจกรรม Friend get Friend') {
              return this.$t('message.friendFetFriend')
            } else {
              return !this.$isTargetShop ? this.$t('message.fromBuyAndService') : this.$t('message.yougetPoint')
            }
          }
        }
      }
      // if (item.source === 'collect') {
      //   if (item.name === 'รายการรับคะแนน') {
      //     if (item.refId !== '' && item.refId !== 'None' && item.refId !== null) {
      //       return `${this.$t('message.billingNo')}: ${item.refId}`
      //     } else {
      //       if (this.$i18n.locale === 'th') {
      //         return item.topicNameTh
      //       } else {
      //         return item.topicNameEng
      //       }
      //     }
      //   } else if (item.name === 'รายการรับคะแนนแบบสอบถาม') {
      //     return `${this.$t('message.billingNo')}: ${item.refId}`
      //   }
      // } else if (item.source === 'redeem') {
      //   if (this.$i18n.locale === 'th') {
      //     return item.topicNameTh
      //   } else {
      //     return item.topicNameEng
      //   }
      // } else {
      //   if (item.refId !== '' && item.refId !== 'None' && item.refId !== null) {
      //     return `${this.$t('message.billingNo')}: ${item.refId}`
      //   } else {

      //   }
      // }
    },
    checkShowOrNot2 (item) {
      if (item.title) {
        return false
      } else if (item.quetionaire) {
        return false
      } else {
        if (item.packageName) {
          return false
        } else {
          if (item.name === 'รายการรับคะแนนจากกิจกรรม Friend get Friend') {
            return false
          } else {
            if (!this.$isTargetShop()) {
              return false
            } else {
              return item.lmgStatusSpecailpoint !== 'True'
            }
          }
        }
      }
    },
    checkTypeNoti2 (item) {
      if (item.title) {
        return this.$t('message.activity')
      } else if (item.quetionaire) {
        return this.$t('message.feedBack')
      } else {
        if (item.packageName) {
          return this.$t('message.package')
        } else {
          if (item.name === 'รายการรับคะแนนจากกิจกรรม Friend get Friend') {
            return this.$t('message.activity')
          } else {
            if (!this.$isTargetShop()) {
              return this.$t('message.productsServices')
            } else {
              return item.lmgStatusSpecailpoint === 'True' ? this.$t('message.specailLMG') : this.$t('message.productsServicesLMG')
            }
          }
        }
      }
    },
    fillData () {
      this.datacollection = {
        labels: this.chartLabel,
        datasets: [
          {
            borderColor: '#CA3433',
            backgroundColor: 'transparent',
            data: this.chartData
          }
        ]
      }
    },
    async getDetailBpv (item) {
      await axios
        .get(
          this.DNS_IP + '/hitorysell/get?DOCNO=' +
            item.bvpBillingNumber
        )
        .then(async (response) => {
          this.dataDetil = response.data
          this.dialog = true
        })
        .catch((error) => {
          console.error(error)
          this.dataReady = true
        })
    },
    async getTransaction () {
      // const result = await axios.get(
      //   this.DNS_IP +
      //     `/notify/get?memberId=${this.profile.memberId}&shopId=${this.shopId}`,
      //   {
      //     headers: {
      //       lineUserId: this.profile.userId,
      //       lineId: this.profile.userId,
      //       shopId: this.shopId
      //     }
      //   }
      // )

      // console.log('resylt', result.data)
      // if (result.data.length > 0) {
      //   this.formUpdate = result.data.filter(item => item.source === )
      //   console.log('ioio', this.formUpdate)
      //   this.notificationshow = result.data.filter(
      //     (item) => item.notifyStatus === 'show'
      //   )
      //   this.notificationshowed = result.data.filter(
      //     (item) => item.notifyStatus === 'showed'
      //   )
      //   this.countNoti = this.notificationshow.length
      //   if (result.data.find((item) => item.notifyStatus === 'showed')) {
      //     this.text = false
      //   } else if (result.data.find((item) => item.notifyStatus === 'show')) {
      //     this.text = true
      //   }
      //   console.log('noti', this.notificationshow)
      //   console.log('notishowed', this.text)
      // } else {
      // }
      await axios
        .get(
          this.DNS_IP + '/activityLog/get?shopId=' +
            this.shopId +
            '&memberId=' +
            this.profile.memberId
        )
        .then(async (response) => {
          if (Array.isArray(response.data)) {
            this.formUpdate = response.data
          } else {
            this.formUpdate = []
          }
        })
        .catch((error) => {
          console.error(error)
          this.dataReady = true
        })
      if (this.shopId === this.shopNameData.bpv) {
        this.datacheck = []
        this.urlQRCode = '/qrcodeBpv/get?shopId='

        this.formUpdate.forEach((item) => {
          if (item.bvpBillingNumber !== '' && item.bvpBillingNumber) {
            if (this.datacheck.some((dataItem) => dataItem.bvpBillingNumber === item.bvpBillingNumber)) {
              this.datacheck.forEach((item2) => {
                let { bvpBillingNumber } = item2
                if (bvpBillingNumber === item.bvpBillingNumber) {
                  item2.coin += parseInt(item.coin)
                }
              })
            } else {
              this.datacheck.push({'bvpBillingNumber': item.bvpBillingNumber, 'coin': parseInt(item.coin), 'quetionaire': 'แบบสอบถาม เลขบิล: ' + item.bvpBillingNumber, 'LAST_DATE': item.LAST_DATE})
            }
          }
        })
        this.formUpdate = this.formUpdate.filter((item) => {
          return item.bvpBillingNumber === '' || !item.bvpBillingNumber
        })
        this.datacheck.forEach(item => this.formUpdate.push(item))
      } else {
        this.urlQRCode = '/qrcode/get?shopId='
      }
      await axios
        .get(
          this.DNS_IP + '/Log_SpecialPoint/get?shopId=' +
            this.shopId +
            '&memberId=' +
            this.profile.memberId
        )
        .then(async (response) => {
          if (Array.isArray(response.data)) {
            this.formUpdate.push({'title': 'Welcome point', 'coin': response.data[0].point, 'LAST_DATE': response.data[0].LAST_DATE})
          }
        })
        .catch((error) => {
          console.error(error)
          this.dataReady = true
        })
      await axios
        .get(
          this.DNS_IP + '/Log_Birthday/get?shopId=' +
            this.shopId +
            '&lineUserId=' +
            this.profile.userId +
            '&status=get'
        )
        .then(async (response) => {
          if (Array.isArray(response.data)) {
            response.data.forEach((item) => {
              this.formUpdate.push({'title': 'BirthDay Point', 'coin': item.point, 'LAST_DATE': item.LAST_DATE})
            })
            // this.formUpdate.push({'title': 'Welcome point', 'coin': response.data[0].point, 'LAST_DATE': response.data[0].LAST_DATE})
          }
        })
        .catch((error) => {
          console.error(error)
          this.dataReady = true
        })
      if (this.notificationshow.length > 0) {
        this.notificationshow.forEach((item) => {
          if (item.packageName) {
            item.coin = item.details.split(' ')[1]
            this.formUpdate.push(item)
          } else if (item.source === 'redeem') {
            item.coin = item.details.split(' ')[1]
            this.dataRedeem.push(item)
          } else if (item.name === 'รายการรับคะแนนจากกิจกรรม Friend get Friend') {
            item.coin = item.details.split(' ')[1]
            this.formUpdate.push(item)
          }
        })
      }
      if (this.notificationshowed.length > 0) {
        this.notificationshowed.forEach((item) => {
          if (item.packageName) {
            item.coin = item.details.split(' ')[1]
            this.formUpdate.push(item)
          } else if (item.source === 'redeem') {
            item.coin = item.details.split(' ')[1]
            this.dataRedeem.push(item)
          } else if (item.name === 'รายการรับคะแนนจากกิจกรรม Friend get Friend') {
            item.coin = item.details.split(' ')[1]
            this.formUpdate.push(item)
          }
        })
      }
      let dataHistoryRefundPoint = []
      await axios
        .get(
          this.DNS_IP +
            '/qrcode_refund/get?shopId=' +
            this.shopId + '&memberId=' + this.profile.memberId +
            '&status=refund'
        )
        .then(async (response) => {
          if (Array.isArray(response.data)) {
            dataHistoryRefundPoint = response.data
            dataHistoryRefundPoint.forEach((item) => {
              this.dataRedeem.push({'source': 'refund', 'coin': item.point, 'refId': item.bvpBillingNumber || item.refId, 'LAST_DATE': item.LAST_DATE})
            })
          }
        })
        .catch((err) => {
          console.error('2', err)
        })
      await axios
        .get(
          this.DNS_IP + this.urlQRCode +
            this.shopId +
            '&memberId=' +
            this.profile.memberId
        )
        .then(async (response) => {
          if (Array.isArray(response.data)) {
            this.formUpdate1 = response.data
            if (this.$isTargetShop()) {
              this.formUpdate1 = this.formUpdate1.sort((a, b) => new Date(b.CREATE_DATE) - new Date(a.CREATE_DATE))
            }
            this.formUpdate.push(...this.formUpdate1)
          }
        })
        .catch((error) => {
          console.error(error)
          this.dataReady = true
        })
      console.error('formUpdate', this.formUpdate)
      if (this.formUpdate.length > 0) {
        this.formUpdate = this.formUpdate.sort((a, b) => new Date(b.LAST_DATE) - new Date(a.LAST_DATE))
      }
      if (this.dataRedeem.length > 0) {
        this.dataRedeem = this.dataRedeem.sort((a, b) => new Date(b.LAST_DATE) - new Date(a.LAST_DATE))
      }
    },
    async getExpireCoin () {
      const result = await this.callBeTaskAPI(
        'get',
        `/get-history-expire-coin-by-useId/get?lineUserId=${this.profile.userId}&shopId=${this.shopId}`
      )
      if (Array.isArray(result)) {
        this.expireCoin = result
      }
    },
    normalizeHex (hex) {
      if (!hex) return null
      let h = String(hex).trim().toLowerCase()
      if (h.startsWith('rgb')) return null
      if (h[0] === '#') h = h.slice(1)
      if (h.length === 3) h = h.split('').map(c => c + c).join('')
      if (h.length !== 6) return null
      return h
    },
    isWhiteTone (color) {
      const h = this.normalizeHex(color)
      if (!h) return false
      const r = parseInt(h.slice(0, 2), 16)
      const g = parseInt(h.slice(2, 4), 16)
      const b = parseInt(h.slice(4, 6), 16)
      const brightness = (r * 299 + g * 587 + b * 114) / 1000
      return brightness >= 240
    }
  }
}
</script>
<style scoped>
.chart_bg {
    background-color: #EDEDED;
}
.myChartDiv {
  width: 100%;
  max-height: 350px;
}
</style>



// WEBPACK FOOTER //
// src/components/Card/C/Transaction.vue